import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
// Memoji images
const MEMOJI_FEMALE_1 = 'https://cdn.magicpatterns.com/uploads/etzGm3E7AqZzoRBR6LW1hA/nastyatoki.png';
const MEMOJI_MALE = 'https://cdn.magicpatterns.com/uploads/kywdwn7LuPV87mnksEkraf/yourawesam.png';
const MEMOJI_FEMALE_2 = 'https://cdn.magicpatterns.com/uploads/ivnUpk1HmHTubmYR1EXQ55/ssemenov.png';
export function Testimonials() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const {
    t
  } = useLanguage();
  const testimonials = [{
    name: t('testimonials.r1.name'),
    text: t('testimonials.r1.text'),
    business: t('testimonials.r1.business'),
    image: MEMOJI_FEMALE_1
  }, {
    name: t('testimonials.r2.name'),
    text: t('testimonials.r2.text'),
    business: t('testimonials.r2.business'),
    image: MEMOJI_MALE
  }, {
    name: t('testimonials.r3.name'),
    text: t('testimonials.r3.text'),
    business: t('testimonials.r3.business'),
    image: MEMOJI_FEMALE_2
  }];
  return <section id="testimonials" ref={ref} className="relative w-full overflow-hidden px-4 py-16 sm:py-24" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-303">
      <div className="relative z-10 mx-auto max-w-7xl" data-id="element-304">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="mb-12 sm:mb-16 text-center" data-id="element-305">
          {/* H2 - Section heading */}
          <h2 className="text-3xl md:text-4xl" style={{
          color: 'var(--text-primary)'
        }} data-id="element-306">
            {t('testimonials.title')} {t('testimonials.titleHighlight')}
          </h2>
        </motion.div>

        {/* Testimonials Grid */}
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-307">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.1 + index * 0.1
        }} data-id="element-308">
              <article className="h-full rounded-2xl border p-6 relative flex flex-col" style={{
            borderColor: 'var(--border)',
            backgroundColor: 'var(--bg-secondary)'
          }} data-id="element-309">
                {/* Quote icon */}
                <QuoteIcon className="absolute top-4 right-4 w-8 h-8 opacity-10" style={{
              color: 'var(--accent)'
            }} data-id="element-310" />

                {/* Author Info (Top) */}
                <div className="flex items-center gap-3 mb-4" data-id="element-311">
                  <div className="w-12 h-12 rounded-full overflow-hidden border border-[var(--border)] flex-shrink-0" style={{
                backgroundColor: 'var(--bg-tertiary)'
              }} data-id="element-312">
                    <img src={testimonial.image} alt={testimonial.name} className="w-full h-full object-cover" data-id="element-313" />
                  </div>
                  <div data-id="element-314">
                    <p className="font-medium text-sm" style={{
                  color: 'var(--text-primary)'
                }} data-id="element-315">
                      {testimonial.name}
                    </p>
                    <p className="text-xs" style={{
                  color: 'var(--text-muted)'
                }} data-id="element-316">
                      {testimonial.business}
                    </p>
                  </div>
                </div>

                {/* 5 Stars */}
                <div className="flex gap-1 mb-4" aria-label="5 out of 5 stars" data-id="element-317">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" style={{
                color: '#FBBF24'
              }} data-id="element-318" />)}
                </div>

                {/* Review text (Bottom) */}
                <blockquote className="text-sm sm:text-base leading-relaxed mt-auto" style={{
              color: 'var(--text-secondary)'
            }} data-id="element-319">
                  "{testimonial.text}"
                </blockquote>
              </article>
            </motion.div>)}
        </div>
      </div>
    </section>;
}